<template>
<div>
   <div :class="this.lite ? 'lite-search-bar' : 'search-bar'">
      <input
         id="search"
         type="search"
         name="input"
         :placeholder="placeHolder"
         v-model="message"
         @keyup.enter="emitClick(message)"
         autocomplete="off"
         :class="this.lite ? 'lite-input' : this.disabled ? 'disabled-input input' : 'input'"
      ><button
         v-if="!this.lite"
         type="button"
         name="search"
         :value="message"
         @click="emitClick(message)"
         :class="this.lite ? 'lite-button' : this.disabled ? 'disabled-button button' : 'button'"
      >Search</button>
      <button v-else class='search-icon' @click="emitClick(message)" ><i class="fal fa-search"></i></button>
   </div>
</div>
</template>

<script>
   export default {
      //pass what the placeholder will be for the input string
      props: {
         placeHolder:{
            type: String,
            required: false,
         },
         value:{
            type: String,
            required: false,
         },
         characterLimit:{
            type: Number,
            required: false
         },
         lite: {
            type: Boolean,
            required: false,
            default: false
         },
         disabled: {
            type: Boolean,
            required: false,
            default: false,
         }
      },
      data: function(){
         return {
            //data holder for the message inside the text input
            message: "",
            notEnoughCharacters: false,
         }
      },
      computed: {
         limitReached: function(){
            return this.message.length >= this.characterLimit
         }
      },
      methods: {
         emitClick(message){
            this.$emit('click', message);
            if(this.limitReached){
               this.notEnoughCharacters = false
            }else{
               this.notEnoughCharacters = true;
            }
         }
      },
      watch: {
         value : function(){
            this.message = this.value;
         },
         limitReached: function(){
            if(this.limitReached){
               this.notEnoughCharacters = false;
            }
         },
         message: function(){
            this.$emit('term', this.message)
         }
      }
   }
</script>

